import Layout from '@/layout/base/layoutSegfy'
import { ROTA_PUBLICA_DA_LOJA, destinoDaLoja } from '@/utils/linkLoja'

export default [{
    // Link direto da loja de aplicativos para LP/campanha (ver utils/linkLoja). O redirect é
    // resolvido antes do guard: deslogado, quem vai para o login é a rota de destino inteira.
    path: ROTA_PUBLICA_DA_LOJA,
    redirect: to => destinoDaLoja(to.query)
}, {
    path: '/financeiro',
    component: Layout,
    children: [
        {
            name: 'financeiro-recebimentos',
            path: 'recebimentos',
            component: () => import('@/components/financeiro/recebimentos'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-fluxo-de-caixa',
            path: 'fluxoCaixa',
            component: () => import('@/components/financeiro/fluxoCaixa'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-parcelas',
            path: 'parcelas',
            component: () => import('@/components/financeiro/parcelas'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-parcelas-atrasadas',
            path: 'parcelasAtrasadas',
            component: () => import('@/components/financeiro/parcelasAtrasadas'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-faturas',
            path: 'faturas',
            component: () => import('@/components/financeiro/faturas'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-extratobancario',
            path: 'extratoBancario',
            component: () => import('@/components/financeiro/extratobancario'),
            meta: {
                auth: true
            }
        },
        {
            name: 'financeiro-meus-pagamentos',
            path: 'meusPagamentos',
            component: () => import('@/components/financeiro/meusPagamentos'),
            meta: {
                auth: true
            }
        }
    ]
}]
